export const dashboardSections = [
    "Dashboard",
    "Commands",
    "Timers",
    "Moderation",
    "Viewers",
    "SleepySnacks",
    "Rewards",
    "Giveaways",
    "SleepyFlow",
    "Alert Studio",
    "OBS Widgets",
    "Logs",
    "Settings",
];
